

exports.__esModule = true;
exports.$AddNationalIdRoute = undefined;

var _squid = require('squid');

require('./directive');

var $AddNationalIdRoute = exports.$AddNationalIdRoute = _squid.$ComponentRoute.extend('$AddNationalIdRoute', {
    path: 'addNationalId',
    directive: 'xo-add-national-id-page',
    titleContent: 'addTaxId.nationalityUpdate',
    trackingData: {
        fptiState: 'add-national-id',
        buzname: {
            'fullpage': {
                'pagename': '%::add-national-id',
                'pagename2': '%::add-national-id:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    children: []
});

angular.value("$AddNationalIdRoute", $AddNationalIdRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-add-national-id/route.js
// module id = ./pages/xo-add-national-id/route.js
// module chunks = 0